import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Container,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import OnlyHeader from "components/Headers/OnlyHeader.js";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { getAllBlogDownloads } from "store/actions/blogsAction";

const BlogSummary = () => {
  const dispatch = useDispatch();
  const { allBlogDownloads, totalPages, getBlogDownloadsLoader } = useSelector(
    (state) => state.blogs
  );

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
    dispatch(getAllBlogDownloads(currentPage, itemsPerPage));
  }, [dispatch, currentPage]);

  const formatTimestamp = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row className="mb-5">
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Blog Downloads</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Blog Title</th>
                    <th scope="col">User Name</th>
                    <th scope="col">User Email</th>
                    <th scope="col">User Phone Number</th>
                    <th scope="col">Download Date</th>
                    <th scope="col"> Total Downloads</th>
                  </tr>
                </thead>
                {!getBlogDownloadsLoader ? (
                  <tbody>
                    {allBlogDownloads && allBlogDownloads.length > 0 ? (
                      allBlogDownloads?.map((download, index) => (
                        <tr key={download._id || index}>
                          <th scope="row">
                            <span className="text-sm">
                              {download.blog?.title ||
                                download.blogTitle ||
                                "-"}
                            </span>
                          </th>
                          <td>{download.name || "-"}</td>
                          <td>{download.email || "-"}</td>
                          <td>
                            {download.phone || download.phoneNumber || "-"}
                          </td>
                          <td>{formatTimestamp(download.downloadedAt)}</td>
                          <td>{download.count}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                          <p className="mb-0 text-sm">
                            No Blog Downloads Found.
                          </p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center" }}>
                        <Spinner
                          size="lg"
                          style={{ display: "block", margin: "0 auto" }}
                        />
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
              {totalPages > 0 && (
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <ReactPaginate
                      previousLabel={"<"}
                      nextLabel={">"}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={handlePageChange}
                      containerClassName={
                        "pagination px-1 justify-content-end mb-0"
                      }
                      activeClassName={"active"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      nextClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextLinkClassName={"page-link"}
                    />
                  </nav>
                </CardFooter>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default BlogSummary;
